import {
  fetchDiscountOption,
  fetchSubscriptionDiscountOptions,
} from '@/clients/pops/client'
import { $discountOptions, $discountOptionWeeks, $promises } from './stores'
import { DiscountOption } from '@/models/discount-option'
import { DiscountOptionWeek } from '@/models/discount-option-week'

export const loadDiscountOption = async ({
  discountOptionId,
  force = false,
}: {
  discountOptionId: number
  force?: boolean
}) => {
  const promiseKey = `loadDiscountOption${discountOptionId}`

  if ($promises.get()[promiseKey] && !force) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const rawDiscountOption = await fetchDiscountOption(discountOptionId)
    const discountOption = new DiscountOption(rawDiscountOption)
    $discountOptions.setKey(String(discountOptionId), discountOption)
  })()

  $promises.setKey(promiseKey, promise)

  return promise
}

export const loadDiscountOptionWeeks = async ({
  subscriptionId,
  force = false,
}: {
  subscriptionId: number
  force?: boolean
}) => {
  const promiseKey = `loadDiscountOptionWeeks${subscriptionId}`
  if ($promises.get()[promiseKey] && !force) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const rawDiscountOptionWeeks =
      await fetchSubscriptionDiscountOptions(subscriptionId)
    const discountOptionWeeks = rawDiscountOptionWeeks.map(
      (rawDiscountOptionWeek) => {
        return new DiscountOptionWeek(rawDiscountOptionWeek)
      },
    )

    $discountOptionWeeks.setKey(String(subscriptionId), discountOptionWeeks)
  })()

  $promises.setKey(promiseKey, promise)

  return promise
}
